import categories from './categories'
import subcategories from './subcategories'
import productSuppliers from './product-suppliers'
import deals from './deals'
import coupons from './coupons'
import retailers from './retailers'
import products from './products'

const shop = [
	...categories,
	...subcategories,
	...productSuppliers,
	...deals,
	...coupons,
	...retailers,
	...products,
	{
		path: '/deals/dashboard',
		name: 'shop-dashboard',
		component: () => import('@/views/shop/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	{
		path: '/deals/categories',
		name: 'shop-categories',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	{
		path: '/deals/sub-categories',
		name: 'shop-sub-categories',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	{
		path: '/deals/messages',
		name: 'shop-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	{
		path: '/deals/newsletter',
		name: 'shop-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	{
		path: '/deals/notifications',
		name: 'shop-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
	// The Shop became Mundo Gamer Deals and its screens moved from /shop/... to /deals/...: bookmarks, shared links and
	// notification links to the old addresses land on the same screen (query string and hash kept). The route names,
	// the ACL modules and the `shop` vertical did not change.
	{
		path: '/shop',
		redirect: { name: 'shop-dashboard' },
	},
	{
		path: '/shop/*',
		redirect: to => ({
			path: to.path.replace(/^\/shop(?=\/|$)/, '/deals'),
			query: to.query,
			hash: to.hash,
		}),
	},
]

export default shop
